import { Directive } from '@angular/core';

@Directive({
  selector: '[jbDialogActionsTop]',
})
export class DialogActionsTopDirective {}
